import React from "react";
import { useNavigate } from "react-router-dom";

const StudentInformationSystem = () => {
  const navigate = useNavigate();

  return (
    <section className="menu-section-bg">
      <div className="menu-container" id="Comprehensive">

        {/* ===== HEADER ===== */}
        <div className="product-subtitleBg-header">
          <h1 className="product-titleBg">
            Student Information System (SIS)
          </h1>
          <p className="product-subtitleBg">
            A centralized platform to manage student data, academics,
            attendance, performance, and communication — securely and
            efficiently.
          </p>
        </div>

        {/* ===== SECTION 1 ===== */}
        <div className="product-and-sol-mainCard ps-two-column-grid product-sol-card">
          <div className="enrollment-image-card product-sol-card-imageBox">
            <img
              src="../images/product&soluction/academicmanagement.jpg"
              alt="Student Dashboard"
              className="ps-main-image"
            />
          </div>

          <div>
            <h2 className="product-and-sol-sectionTitle">
              Unified Student Data Management
            </h2>
            <p className="product-and-sol-section-text">
              Our SIS acts as the digital backbone of your institution, managing
              complete student records from admission to alumni with accuracy,
              accessibility, and compliance.
            </p>

            <ul className="product-and-sol-list">
              <li>✔ Centralized student profiles</li>
              <li>✔ Academic & demographic data</li>
              <li>✔ Attendance & behavior tracking</li>
              <li>✔ Secure role-based access</li>
            </ul>

            <div
              className="read-more-btn"
              onClick={() =>
                navigate(
                  "/student-information-system/read-more#StudentInformationSystem"
                )
              }
            >
              Read more →
            </div>
          </div>
        </div>

        {/* ===== SECTION 2 ===== */}
        <div className="product-and-sol-secondCard ps-two-column-grid product-sol-card">
          <div>
            <h2 className="product-and-sol-sectionTitle">
              Comprehensive SIS for K-12 Schools
            </h2>
            <p className="product-and-sol-section-text">
              A modern Student Information System is the central nervous system
              of any K-12 institution, powering academics, operations, and
              engagement across the school community.
            </p>

            <ul className="product-and-sol-list">
              <li>✔ Enrollment & demographics</li>
              <li>✔ Attendance & scheduling</li>
              <li>✔ Grades & academic tracking</li>
              <li>✔ Behavior & discipline</li>
              <li>✔ Health & special education</li>
              <li>✔ Reporting & analytics</li>
              <li>✔ Parent & student communication</li>
              <li>✔ Financial & billing management</li>
              <li>✔ Integrations & customization</li>
            </ul>

            <div
              className="read-more-btn"
              onClick={() =>
                navigate(
                  "/student-information-system/read-more#StudentInformationSystem"
                )
              }
            >
              Read more →
            </div>
          </div>

          <div className="student-image-card product-sol-card-imageBox">
            <img
              src="../images/product&soluction/StudentInformationSystem1.jpg"
              alt="Student Records"
              className="ps-main-image"
            />
          </div>
        </div>

        {/* ===== SECTION 3 ===== */}
        <div className="product-and-sol-mainCard ps-two-column-grid product-sol-card">
          <div className="student-product-image-card product-sol-card-imageBox">
            <img
              src="../images/product&soluction/Admission&Enrollment.jpg"
              alt="Academic Management"
              className="ps-main-image"
            />
          </div>

          <div>
            <h2 className="product-and-sol-sectionTitle">
              Empower Your School with Academic Management
            </h2>
            <p className="product-and-sol-section-text">
              Deliver high-quality instruction, track progress, and foster
              collaboration using data-driven academic tools.
            </p>

            <ul className="product-and-sol-list">
              <li>✔ Improved student engagement</li>
              <li>✔ Streamlined assessments</li>
              <li>✔ Actionable data insights</li>
              <li>✔ Enhanced collaboration</li>
              <li>✔ Compliance & security</li>
              <li>✔ Cost efficiency</li>
              <li>✔ Scalable architecture</li>
            </ul>

            <div
              className="read-more-btn"
              onClick={() =>
                navigate("/student-information-system/read-more#Empower")
              }
            >
              Read more →
            </div>
          </div>
        </div>

        {/* ===== SECTION 4 ===== */}
        <div className="product-and-sol-mainCard ps-two-column-grid product-sol-card">
          <div>
            <h2 className="product-and-sol-sectionTitle">
              Unlock School-Wide Efficiency with Administrative Console
            </h2>
            <p className="product-and-sol-section-text">
              Gain visibility and control over daily operations with powerful
              administrative tools.
            </p>

            <ul className="product-and-sol-list">
              <li>✔ Unified visibility</li>
              <li>✔ Granular controls</li>
              <li>✔ Operational streamlining</li>
              <li>✔ Data security & compliance</li>
              <li>✔ Time & cost savings</li>
              <li>✔ Scalable infrastructure</li>
            </ul>

            <div
              className="read-more-btn"
              onClick={() =>
                navigate("/student-information-system/read-more#Unlock")
              }
            >
              Read more →
            </div>
          </div>

          <div className="student-Unlock-image-card product-sol-card-imageBox">
            <img
              src="../images/product&soluction/Admission&Enrollment.jpg"
              alt="Administrative Console"
              className="ps-main-image"
            />
          </div>
        </div>

        {/* ===== FEATURES ===== */}
        <div className="ps-feature-grid">

          <FeatureCard
            typeClass="credentialing"
            backgroundColor="#e9fdf3"
            icon={icons.profile}
            title="Student Profiles"
            description="Maintain complete student records including personal details and history."
          />

          <FeatureCard
            typeClass="wallet"
            backgroundColor="#f3ecff"
            icon={icons.academics}
            title="Academic Records"
            description="Track grades, subjects, assessments, and report cards."
          />

          <FeatureCard
            typeClass="human-resources"
            backgroundColor="#f1f6ff"
            icon={icons.attendance}
            title="Attendance Management"
            description="Monitor attendance, leaves, and compliance-ready reports."
          />

          <FeatureCard
            typeClass="education"
            backgroundColor="#fff3cc"
            icon={icons.communication}
            title="Parent & Student Communication"
            description="Real-time notifications and engagement tools."
          />

          <FeatureCard
            typeClass="marketing"
            backgroundColor="#ffe6dc"
            icon={icons.security}
            title="Data Security & Compliance"
            description="Role-based access, audit logs, and data protection."
          />

          <FeatureCard
            typeClass="analytics"
            backgroundColor="#eaf9fa"
            icon={icons.analytics}
            title="Insights & Reports"
            description="Real-time dashboards and customizable reports."
          />

        </div>

        {/* ===== CTA ===== */}
        <div className="ps-highlight-wrapper">
          <div className="ps-highlight-card">

            <div className="ps-highlight-header">
              <h2 className="ps-highlight-title">
                Build a Smarter Student Experience
              </h2>
              <p className="ps-highlight-subtitle">
                One system. One source of truth.
              </p>
            </div>

            <div className="ps-highlight-body">
              <p className="ps-highlight-text">
                Empower administrators, teachers, students, and parents with a
                unified platform for all student-related information.
              </p>

              <div className="ps-button-group">
                <button
                  className="Demo-button"
                  onClick={() => navigate("/contact#Contact-form")}
                >
                  Schedule a Demo
                </button>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

/* ===== SHARED FEATURE CARD ===== */
const FeatureCard = ({
  icon,
  title,
  description,
  backgroundColor,
  typeClass
}) => (
  <div
    className={`card product-soluction-card ${typeClass}`}
    style={{ backgroundColor }}
  >
    <div className="card-overlay"></div>

    <div className="circle">
      <div className="ps-card-icon">{icon}</div>
    </div>

    <h3 className="ps-card-title">{title}</h3>
    <p className="product-soluction-card-text">{description}</p>
  </div>
);

/* ===== ICONS ===== */
const icons = {
  profile: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="4" stroke="#5a5cff" strokeWidth="2" />
      <path d="M4 20c0-4 16-4 16 0" stroke="#5a5cff" strokeWidth="2" />
    </svg>
  ),
  academics: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M3 6l9-3 9 3-9 3-9-3z" stroke="#ff8c00" strokeWidth="2" />
      <path d="M3 10l9 3 9-3" stroke="#ff8c00" strokeWidth="2" />
      <path d="M7 13v4c0 1 10 1 10 0v-4" stroke="#ff8c00" strokeWidth="2" />
    </svg>
  ),
  attendance: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <rect x="4" y="3" width="16" height="18" rx="2" stroke="#0ca85c" strokeWidth="2" />
      <path d="M8 11l2 2 4-4" stroke="#0ca85c" strokeWidth="2" />
    </svg>
  ),
  communication: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M21 15a4 4 0 0 1-4 4H7l-4 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"
        stroke="#e74c3c" strokeWidth="2" />
    </svg>
  ),
  security: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M12 3l8 4v6c0 5-3.5 7.5-8 9-4.5-1.5-8-4-8-9V7l8-4z"
        stroke="#6c5ce7" strokeWidth="2" />
    </svg>
  ),
  analytics: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M4 20V10M10 20V4M16 20v-8" stroke="#0097e6" strokeWidth="2" />
    </svg>
  ),
};

export default StudentInformationSystem;
